export default "__VITE_ASSET__DjcJEUa1__"